import { businessUnits } from '../../businessUnitConfig';

export class MissionUrl {
  private missionUrl: string;
  private applyUrl: string;

  private localizedMissionUrl: string;
  private localizedApplyUrl: string;

  constructor(
    private readonly businessUnit: string,
    private readonly slug: string,
  ) {}

  private getApplySuffix(): string {
    return `/${businessUnits[this.businessUnit].paths.apply}`;
  }

  private getMissionUrl(): string {
    if (!this.missionUrl) {
      this.missionUrl = `/${businessUnits[this.businessUnit].paths.jobOffer}/${this.slug}`;
    }
    return this.missionUrl;
  }

  private getApplyUrl(): string {
    if (!this.applyUrl) {
      this.applyUrl = `${this.getMissionUrl()}${this.getApplySuffix()}`;
    }
    return this.applyUrl;
  }

  getLocalizedMissionUrl(): string {
    if (!this.localizedMissionUrl) {
      this.localizedMissionUrl = `/${this.businessUnit.toLowerCase()}${this.getMissionUrl()}`;
    }
    return this.localizedMissionUrl;
  }

  getLocalizedApplyUrl(): string {
    if (!this.localizedApplyUrl) {
      this.localizedApplyUrl = `/${this.businessUnit.toLowerCase()}${this.getApplyUrl()}`;
    }
    return this.localizedApplyUrl;
  }

  isApplyUrl(url: string): boolean {
    return url.split('?')[0].endsWith(this.getApplySuffix());
  }

  static extractSlug(url: string) {
    return url.split('?')[0].split('/')[3];
  }
}
